export default "__VITE_ASSET__540d8339__"